(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pb-carousel"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.pb-carousel').forEach(function(root){
  if(root.dataset.pbInit) return;
  root.dataset.pbInit = "1";
  var track = root.querySelector('.pb-car-track');
  var slides = root.querySelectorAll('.pb-car-slide');
  var dotsWrap = root.querySelector('.pb-car-dots');
  var prevBtn = root.querySelector('.pb-car-prev');
  var nextBtn = root.querySelector('.pb-car-next');
  var current = 0;
  slides.forEach(function(_, i){
    var d = document.createElement('div');
    d.className = 'pb-dot' + (i === 0 ? ' active' : '');
    d.addEventListener('click', function(){ goTo(i); });
    dotsWrap.appendChild(d);
  });
  function goTo(i){
    current = (i + slides.length) % slides.length;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    dotsWrap.querySelectorAll('.pb-dot').forEach(function(d, idx){ d.classList.toggle('active', idx === current); });
  }
  if(prevBtn) prevBtn.addEventListener('click', function(){ goTo(current - 1); });
  if(nextBtn) nextBtn.addEventListener('click', function(){ goTo(current + 1); });
  var timer = setInterval(function(){ goTo(current + 1); }, 5500);
  root.addEventListener('mouseenter', function(){ clearInterval(timer); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-features"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e){
  var tab = e.target.closest('.pb-feat-tab');
  if(!tab) return;
  var shell = tab.closest('.pb-feat-shell');
  if(!shell) return;
  shell.querySelectorAll('.pb-feat-tab').forEach(function(t){ t.classList.remove('active'); });
  shell.querySelectorAll('.pb-feat-pane').forEach(function(p){ p.classList.remove('active'); });
  tab.classList.add('active');
  var pane = shell.querySelector('#' + tab.dataset.pbpane);
  if(pane) pane.classList.add('active');
});

  } catch(e) { console.error(e); }
})();
})();
